module.exports = __webpack_public_path__ + "img/left.2122f3c5.svg";